export * from "./search-icon.component";
